import React, { Component } from 'react'
import PropTypes from 'prop-types'

import List from './components/List'

const propTypes = {
  items: PropTypes.array.isRequired,
  selectedItem: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]),
  onItemClick: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func,
}

const defaultProps = {
  selectedItem: false,
  onSelectionChange: (selected) => {},
}

class ListContainer extends Component {
  constructor() {
    super()

    this.onItemClick = this.onItemClick.bind(this)
  }

  selectedItemData() {
    const { items, selectedItem } = this.props
    if (!items || items.length === 0) {
      return
    }
    const index = items.findIndex((item) => item.id === selectedItem)
    if (index === -1) {
      return
    }
    const selected = items[index]
    return { index, selected, items }
  }

  emitSelectedItemData() {
    const data = this.selectedItemData()
    data && this.props.onSelectionChange(data)
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.selectedItem !== this.props.selectedItem ||
      this.props.items.length !== prevProps.items.length
    ) {
      this.emitSelectedItemData()
    }
  }

  componentDidMount() {
    this.emitSelectedItemData()
  }

  onItemClick(val) {
    const { onItemClick } = this.props

    // call parent onItemClick method
    if (typeof onItemClick === 'function') {
      onItemClick(val)
    }
  }

  render() {
    const { items, selectedItem } = this.props

    return (
      <List
        items={items}
        selectedItem={selectedItem}
        onItemClick={this.onItemClick}
      />
    )
  }
}

ListContainer.propTypes = propTypes
ListContainer.defaultProps = defaultProps

export default ListContainer
